module.exports = __webpack_public_path__ + "img/floor8.67ac31e2.png";